// extracted by mini-css-extract-plugin
export default {"routineblock":"hV","container":"iV","carousel":"jV","routine":"kV","heading":"lV","routinelist":"mV","routineitem":"nV","routineimg":"oV","routinedesc":"pV","routinename":"qV","routinetext":"rV","carouselwrap":"sV"};
    if(module.hot) {
      // 1726593107528
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  